import React from 'react';
import { Tooltip } from '@amzn/storm-ui';
import { StyledButton, TooltipWrapper, TooltipInner } from './CustomButton.styles';

interface CustomButtonProps {
  id?: string;
  text: string;
  backgroundColor?: string;
  handleOnClickCb?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  tooltip?: string;
}

export const CustomButton: React.FC<CustomButtonProps> = ({
  id,
  backgroundColor,
  handleOnClickCb,
  text,
  disabled = false,
  tooltip,
}) => {

  const button = (
    <StyledButton
      id={id}
      backgroundColor={backgroundColor}
      onClick={handleOnClickCb}
      disabled={disabled}
      variant="primary"
      type="button"
    >
      {text}
    </StyledButton>
  );

  if (tooltip) {
    return (
      <Tooltip
        message={tooltip}
        position="top"
        variant="default"
        spacing={8}
        align="center"
        trigger={
          <TooltipWrapper>
            <TooltipInner>{button}</TooltipInner>
          </TooltipWrapper>
        }
      />
    );
  }

  return button;
};
